module.exports = __webpack_public_path__ + "static/media/home_delivery.ff7d487a.png";